// extracted by mini-css-extract-plugin
module.exports = {"containerAuthor":"Modal_containerAuthor__xXgLf","CloseButton":"Modal_CloseButton__5YO0R","responseModal":"Modal_responseModal__adMAJ"};